<div class="flex flex-col gap-2">
    <a [attr.href]="collectionUrl" class="flex flex-row gap-2 bg-slate-100 rounded shadow-sm items-center text-xs sm:text-sm hover:cursor-pointer">
        <div class="min-w-[10ch] sm:min-w-[20ch] bg-ponder-light text-slate-50 p-2 rounded-l hover:text-white hover:bg-ponder-xlight">
            {{ collectionPreview.game }}
        </div>
        <div class="pt-2 pb-2 text-right">
            {{ getCardCount() }}
        </div>
        <div class="text-slate-400">|</div>
        <div class="pt-2 pb-2 text-center">
            {{ getDistinctCardCount() }}
        </div>
        <div class="text-slate-400">|</div>
        <div class="pt-2 pb-2">
            {{ getTotalValue() }}
        </div>
    </a>
    <div class="flex flex-row">
        <div class="flex flex-row gap-0 sm:gap-1 overflow-auto min-scrollbar-dark pt-2 pb-2 sm:pl-2 sm:pr-2">
            @for (item of collectionPreview.topItems ; track item.item.id) {
                <preview-item [previewItem]="item!" loadingStrategy="eager" [sizeModifier]="0.8" [hideHighlight]="true" [showOnlyCollectedValue]="true"></preview-item>
            }
        </div>
        <div class="grow min-w-[1px]"></div>
    </div>
</div>